import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import logo from "../../assets/image/logo.jpeg";
import { BASE_URL } from "../../utils/constant";
import axios from "axios";
import { toast } from "react-toastify";
import ReactFlagsSelect from "react-flags-select";
import { Button, Col, Row, Spinner } from "react-bootstrap";

function Register() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("");

  const onSubmit = async (data) => {
    setLoading(true);
    const newData = { ...data, country: country || "India" };

    try {
      const response = await axios.post(`${BASE_URL}/users/signup/`, newData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response && response.data && response.data.message) {
        toast.success(response.data.message);
      }
      if (response) {
        localStorage.setItem("email_or_phone", data.email_or_phone);
        navigate("/otpverification");
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
  <section className="vh-100 d-flex justify-content-center align-items-center">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-md-10 col-lg-8">
        <div
          className="card border-0 shadow-lg overflow-hidden rounded-5 d-flex flex-column flex-md-row"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.97)",
          }}
        >
          <div
            className="col-md-6 d-none d-md-flex justify-content-center align-items-center p-0"
            style={{
              backgroundColor: "#f9fafb",
            }}
          >
            <img
              src={logo}
              alt="Signup"
              className="img-fluid w-100 h-100"
              style={{
                objectFit: "cover",
                filter: "brightness(0.95)",
              }}
            />
          </div>
          <div
            className="col-md-6 col-12 d-flex align-items-center justify-content-center"
            style={{
              padding: "2rem 1.5rem",
              minHeight: "500px",
              backgroundColor: "#ffffff",
            }}
          >
            <div className="w-100" style={{ maxWidth: "400px" }}>
              <div className="text-center mb-4">
                <h2 className="fw-bold" style={{ fontSize: "1.9rem", color: "#222" }}>
                  Create Your Account
                </h2>
                <p style={{ color: "#666", fontSize: "1rem" }}>
                  Fill in your details to get started!
                </p>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col>
                    <div className="form-floating mb-4 custom-input-container">
                      <input
                        type="text"
                        className={`form-control custom-input ${
                          errors.first_name ? "is-invalid" : ""
                        }`}
                        {...register("first_name", {
                          required: "First Name is required",
                        })}
                        placeholder="First Name"
                      />
                      <label htmlFor="first_name" className="custom-label">
                        First Name*
                      </label>
                      {errors.first_name && (
                        <div className="invalid-feedback">
                          {errors.first_name.message}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-floating mb-4 custom-input-container">
                      <input
                        type="text"
                        className={`form-control custom-input ${
                          errors.last_name ? "is-invalid" : ""
                        }`}
                        {...register("last_name")}
                        placeholder="Last Name"
                      />
                      <label htmlFor="last_name" className="custom-label">
                        Last Name
                      </label>
                    </div>
                  </Col>
                </Row>

                <div className="form-floating mb-4 custom-input-container">
                  <input
                    type="text"
                    className={`form-control custom-input ${
                      errors.email_or_phone ? "is-invalid" : ""
                    }`}
                    {...register("email_or_phone", {
                      required: "Mobile number or email is required",
                      pattern: {
                        value: /^(?:\d{10}|\S+@\S+\.\S+)$/,
                        message: "Invalid mobile number or email format",
                      },
                    })}
                    placeholder="Mobile Number or Email"
                  />
                  <label htmlFor="email_or_phone" className="custom-label">
                    Email or Mobile Number*
                  </label>
                  {errors.email_or_phone && (
                    <div className="invalid-feedback">
                      {errors.email_or_phone.message}
                    </div>
                  )}
                </div>

                <Row>
                  <Col>
                    <div className="form-floating mb-4 custom-input-container">
                      <input
                        type="text"
                        className={`form-control custom-input ${
                          errors.company_name ? "is-invalid" : ""
                        }`}
                        {...register("company_name", {
                          required: "Company Name is required",
                        })}
                        placeholder="Company Name"
                      />
                      <label htmlFor="company_name" className="custom-label">
                        Company Name*
                      </label>
                      {errors.company_name && (
                        <div className="invalid-feedback">
                          {errors.company_name.message}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-floating mb-4 custom-input-container">
                      <select
                        className={`form-control custom-input ${
                          errors.industry_type ? "is-invalid" : ""
                        }`}
                        {...register("industry_type", {
                          required: "Industry Type is required",
                        })}
                      >
                        <option value="">Select Industry Type</option>
                        <option value="service_sector">Service Provider</option>
                        <option value="residential">Residential / Society</option>
                      </select>
                      <label htmlFor="industry_type" className="custom-label">
                        Industry Type*
                      </label>
                      {errors.industry_type && (
                        <div className="invalid-feedback">
                          {errors.industry_type.message}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                <div className="btn-container d-flex justify-content-end mt-4">
                  <button className="login-btn" disabled={loading}>
                    {loading ? (
                      <div
                        className="spinner-border text-light"
                        role="status"
                        style={{ width: "1rem", height: "1rem" }}
                      ></div>
                    ) : (
                      "Register"
                    )}
                  </button>
                </div>

                <p className="text-center mt-4">
                  Already have an account?{" "}
                  <Link
                    to="/signin"
                    className="text-decoration-none fw-semibold Link"
                  >
                    Sign In
                  </Link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



    
  );
}

export default Register;
